import { Component, Injectable, Inject } from '@angular/core';
import { CommonFunctionsService } from '@angular/synthrone-design/services';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardViewComponent {

  constructor(@Inject(CommonFunctionsService) public commonFunctions) { 
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/dashboard/dashboard.component.ts